"use strict";

// Generated by CoffeeScript 1.12.7
(function () {
  var XMLCData,
    XMLNode,
    extend = function extend(child, parent) {
      for (var key in parent) {
        if (hasProp.call(parent, key)) child[key] = parent[key];
      }
      function ctor() {
        this.constructor = child;
      }
      ctor.prototype = parent.prototype;
      child.prototype = new ctor();
      child.__super__ = parent.prototype;
      return child;
    },
    hasProp = {}.hasOwnProperty;
  XMLNode = require('./XMLNode');
  module.exports = XMLCData = function (superClass) {
    extend(XMLCData, superClass);
    function XMLCData(parent, text) {
      XMLCData.__super__.constructor.call(this, parent);
      if (text == null) {
        throw new Error("Missing CDATA text. " + this.debugInfo());
      }
      this.text = this.stringify.cdata(text);
    }
    XMLCData.prototype.clone = function () {
      return Object.create(this);
    };
    XMLCData.prototype.toString = function (options) {
      return this.options.writer.set(options).cdata(this);
    };
    return XMLCData;
  }(XMLNode);
}).call(this);